<span class="ant-table-row-indent" *ngIf="dwIndentSize >= 0" [style.padding-left.px]="dwIndentSize"></span>
<label
  *ngIf="dwShowCheckbox"
  dw-checkbox
  [dwDisabled]="dwDisabled"
  [(ngModel)]="dwChecked"
  [dwIndeterminate]="dwIndeterminate"
  (ngModelChange)="dwCheckedChange.emit($event)">
</label>
<span
  *ngIf="!dwShowExpand && dwIndentSize != null"
  class="ant-table-row-expand-icon ant-table-row-spaced"></span>
<span
  *ngIf="dwShowExpand"
  class="ant-table-row-expand-icon"
  (click)="expandChange()"
  [class.ant-table-row-expanded]="dwExpand"
  [class.ant-table-row-collapsed]="!dwExpand"></span>
<ng-content></ng-content>